export default class CustomTrixEditor {
  constructor() {
    $("trix-editor").css("min-height", "250px");
    $(".trix-button-group--file-tools").hide();
  }
}
